// @ts-nocheck
import { encodeJson as encodeJson_1, decodeJson as decodeJson_1, encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "../../../Pageable";
import { encodeJson as encodeJson_2, decodeJson as decodeJson_2, encodeBinary as encodeBinary_2, decodeBinary as decodeBinary_2, } from "./(ListUserAuthorityRequest)/Filter";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../runtime/json/scalar";
import { WireType, } from "../../../../runtime/wire/index";
import { default as serialize, } from "../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        userId: "0",
        pageable: undefined,
        filter: undefined,
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.userId !== undefined)
        result.userId = tsValueToJsonValueFns.int64(value.userId);
    if (value.pageable !== undefined)
        result.pageable = encodeJson_1(value.pageable);
    if (value.filter !== undefined)
        result.filter = encodeJson_2(value.filter);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.userId !== undefined)
        result.userId = jsonValueToTsValueFns.int64(value.userId);
    if (value.pageable !== undefined)
        result.pageable = decodeJson_1(value.pageable);
    if (value.filter !== undefined)
        result.filter = decodeJson_2(value.filter);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.userId !== undefined) {
        const tsValue = value.userId;
        result.push([1, tsValueToWireValueFns.int64(tsValue)]);
    }
    if (value.pageable !== undefined) {
        const tsValue = value.pageable;
        result.push([2, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    if (value.filter !== undefined) {
        const tsValue = value.filter;
        result.push([3, { type: WireType.LengthDelimited, value: encodeBinary_2(tsValue) }]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.userId = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.pageable = value;
    }
    field: {
        const wireValue = wireFields.get(3);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_2(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.filter = value;
    }
    return result;
}
